import { render } from "./GoogleCallback.vue?vue&type=template&id=21317d74"
import script from "./GoogleCallback.vue?vue&type=script&lang=js"
export * from "./GoogleCallback.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__